import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import type { Observable } from "rxjs";

import { environment } from "../../../../environments/environment";

@Injectable({ providedIn: "root" })
export class PasswordResetInitService {
    private http = inject(HttpClient);

    save(mail: string): Observable<any> {
        return this.http.post(
            environment.apiUrl + "api/account/reset-password/init",
            mail,
        );
    }
}
